import React, { useState, useRef, useEffect } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { gsap } from 'gsap';
import { Link } from 'react-router-dom';

const NavMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isOpen) {
      gsap.to(menuRef.current, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power4.out',
        zIndex: 999999,
      });
    } else {
      gsap.to(menuRef.current, {
        x: '100%',
        opacity: 0,
        duration: 0.8,
        ease: 'power4.in',
        onComplete: () => {
          gsap.set(menuRef.current, { zIndex: -1 });
        }
      });
    }
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      {/* Glassy Menu Button */}
      <button
        onClick={toggleMenu}
        className={`text-2xl md:px-8 px-0 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-0 fixed top-4 border-0 
          right-4 z-[9999999] transition-all duration-300 ring-0 outline-none
           ${
          isOpen 
            ? 'text-white' 
            : isScrolled 
              ? 'text-gray-800' 
              : 'text-black'
        }`}
      >
        {isOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* Glassy Menu Overlay */}
      <div
        ref={menuRef}
        className="fixed top-0 right-0 w-full h-full backdrop-blur-xl bg-black/40 border-l border-white/20 shadow-2xl text-white flex flex-col items-center justify-center z-50"
        style={{ transform: 'translateX(100%)' }}
      >
        {/* Additional Dark Glassy Background Layer */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/50 to-black/30"></div>
        
        {/* Subtle Pattern Overlay */}
        <div className="absolute inset-0 opacity-40">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-900/20 via-purple-900/20 to-gray-900/20"></div>
        </div>

        {/* Menu Content */}
        <div className="relative z-10">
          <ul className="flex flex-col justify-center md:flex-row md:text-5xl text-3xl md:gap-8 gap-4 text-center lg:text-left">
            <li className='transition-all duration-300'>
              <Link to="/project" className='tracking-widest hover:text-blue-200 transition-colors duration-300' onClick={toggleMenu}>
                Project
              </Link>
            </li>
            {/* <li className='hidden md:block w-[1px] h-12 bg-white/20'/>
            <li className='transition-all duration-300'>
            <Link to="/blogs" className='tracking-widest hover:text-blue-200 transition-colors duration-300' onClick={toggleMenu}>
                Blog
              </Link>
            </li> */}
            <li className='hidden md:block w-[1px] h-12 bg-white/20'/>
            <li className='transition-all duration-300'>
            <Link to="/contact" className='tracking-widest hover:text-blue-200 transition-colors duration-300' onClick={toggleMenu}>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Decorative Elements - Darker Colors */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-blue-900/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-purple-900/30 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-gray-900/20 rounded-full blur-3xl"></div>
      </div>
    </div>
  );
};

export default NavMenu;
